import React, {CSSProperties, Dispatch, FC, PropsWithChildren, ReactNode, SetStateAction, useEffect, useState} from 'react';
import {Button, ButtonToolbar, Card, Icon} from '@mc/ui-v4';
import {IconProp} from '@fortawesome/fontawesome-svg-core';
import classNames from 'classnames';
import {mcMaxSize, mcMinSize, mcMinimize} from '@mc/react-ui-icons';
import './SidebarContent.scss';
import {useIsMobile} from '../../hooks/useIsMobile';

type Props = {
    className?: string;
    icon?: IconProp;
    onClose?: () => void;
    style?: CSSProperties;
    title: string | React.JSX.Element;
    wrapContent?: boolean;
    extra?: ReactNode;
    isMaximized?: boolean;
    setIsMaximized?: Dispatch<SetStateAction<boolean>>;
    isFeatureDetail?: boolean;
    iconIntent?: 'default' | 'primary' | 'inherit' | 'success' | 'warning' | 'danger' | 'secondary' | 'inactive';
};

export const SidebarContent: FC<PropsWithChildren<Props>> = ({
    className,
    children,
    icon,
    onClose,
    style,
    title,
    wrapContent = true,
    extra,
    isMaximized,
    setIsMaximized,
    isFeatureDetail = false,
    iconIntent = 'primary',
}) => {
    const isMobile = useIsMobile();
    return (
        <Card
            className={classNames(`card-border drop-shadow position-absolute sidebar-content ${isMaximized ? 'sidebar-min' : 'sidebar-max'} z-10`, className, {
                ['wrap-content']: wrapContent,
            })}
            mode={'edit'}
            style={{...style, zIndex: 10}}
            extra={
                <ButtonToolbar>
                    {extra}
                    {isFeatureDetail && !isMobile && (
                        <Button
                            title={isMaximized ? 'Skrýt rozšířený detail' : 'Zobrazit rozšířený detail'}
                            onClick={() => setIsMaximized(!isMaximized)}
                            icon={isMaximized ? <Icon icon={mcMinSize} size={'sm'} /> : <Icon icon={mcMaxSize} size={'sm'} />}
                            style={'link'}
                        />
                    )}
                    {onClose && <Button icon={<Icon icon={mcMinimize} size={'lg'} />} onClick={onClose} style={'link'}/>}
                </ButtonToolbar>
            }
            title={
                <>
                    {icon && <Icon className={'mr-1'} intent={iconIntent} icon={icon} />}
                    {title}
                </>
            }
            noScroll
        >
            {children}
        </Card>
    );
};
